import axios from 'axios';

const API = axios.create({
  baseURL: 'https://origin-console-service.onrender.com/api/campaign',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const prizes = {
  async getListPrizes() {
    try {
      const res = await API.get('/spin/prizes');
      return res.data;
    } catch (err) {
      console.error('getListPrizes error:', err);
      return null;
    }
  },

  async spin() {
    try {
      const res = await API.post('/spin', {});
      return res.data;
    } catch (err) {
      console.error('spin error:', err);
      return null;
    }
  }
};